import { useEffect, useMemo, useState } from "react";

import type { TChannelSettings } from "@/models/channelSettings.model";
import { BASE_URL, CHAT_CHANNEL } from "@/constants/common";

export const useChannelSettings = () => {
  const [settings, setSettings] = useState<TChannelSettings | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isCancelled = false;

    const fetchSettings = async () => {
      try {
        const response = await fetch(`${BASE_URL}channels/${CHAT_CHANNEL}/settings`);

        if (!response.ok) {
          throw new Error(`Failed to load channel settings: ${response.status}`);
        }

        const data = (await response.json()) as TChannelSettings;
        if (!isCancelled) setSettings(data);
      } catch (error) {
        console.error('[settings] failed to load channel settings:', error);
      } finally {
        if (!isCancelled) setIsLoading(false);
      }
    };

    fetchSettings();

    return () => {
      isCancelled = true;
    };
  }, []);

  return useMemo(() => ({ settings, isLoading }), [settings, isLoading]);
};
